import ApiModel from 'models/api-model';
import { MenuOption } from 'models/utils/common/menu/menu-option-model';
import { WORKPAPER_AUTO_TIEOUT_TOOLTIP } from 'constants/feature/workpaper-panel-constants';
import {
  AUTO_TIEOUT_WORKPAPER_TYPE,
  AUTO_TIEOUT_TB_WORKPAPER_TYPE,
} from 'constants/feature/statement-creation-constants';
import WorkpaperForm from '../form/workpaper-form-model';
import { isNullOrUndefined } from '../../utils/object-utils';
import { WORKPAPER_TYPE } from 'constants/feature/element-panel-constants';
export class WorkpaperReferenceList extends ApiModel({
  data: {
    workpapers: [],
  },
}) {
  get workpapers() {
    return this.data.workpapers;
  }

  processResponse({ response }) {
    const workpapersToDisplay = response?.data?.result?.filter((workpaper) => {
      return workpaper?.workpaperType !== WORKPAPER_TYPE.OMNIA_TRIAL_BALANCE;
    });

    return {
      data: {
        workpapers: workpapersToDisplay || [],
      },
      status: response.status,
    };
  }

  getSelectedWorkpaper(id) {
    const filteredWorkpapers = this.data.workpapers.find(
      (workpaper) => workpaper.workpaperRefId === id,
    );
    return new WorkpaperForm({
      data: {
        revisionId: filteredWorkpapers.revisionId,
        elementId: filteredWorkpapers.elementId,
        referenceNumber: filteredWorkpapers.referenceNumber,
        referenceName: filteredWorkpapers.referenceName,
        workpaperRefId: filteredWorkpapers.workpaperRefId,
        workpaperRefCreatedBy: filteredWorkpapers.workpaperRefCreatedBy,
        workpaperRefCreatedDate: filteredWorkpapers.workpaperRefCreatedDate,
        creationType: filteredWorkpapers.creationType,
      },
    });
  }

  getWorkpaperDropdownValues({ alreadyAddedWorkpaperIds }) {
    let workpaperDropdownOptions = {};
    this.data.workpapers.forEach((workpaper) => {
      const isAlreadyAdded = !isNullOrUndefined(
        alreadyAddedWorkpaperIds.find((id) => id === workpaper.workpaperRefId),
      );
      const isAutoTieout =
        workpaper.workpaperType === AUTO_TIEOUT_WORKPAPER_TYPE ||
        workpaper.workpaperType === AUTO_TIEOUT_TB_WORKPAPER_TYPE;
      workpaperDropdownOptions[workpaper.workpaperRefId] = new MenuOption({
        id: workpaper.workpaperRefId,
        title: workpaper.referenceNumber,
        value: workpaper.referenceNumber,
        isIntl: false,
        disabled: isAlreadyAdded || isAutoTieout,
        tooltip: isAutoTieout ? WORKPAPER_AUTO_TIEOUT_TOOLTIP : undefined,
      });
    });

    return Object.values(workpaperDropdownOptions);
  }

  getFilteredWorkpaperRefs(term) {
    return this.data.workpapers.filter(
      (workpaper) =>
        workpaper.referenceNumber.toLowerCase().indexOf(term.toLowerCase()) !==
        -1,
    );
  }
}
